import { Box, Dialog, DialogContent, Typography, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from '../../components/Button';
import { tokens } from '../../theme';
import { useTranslation } from '../../hooks/useTranslation';

const ModalRequestAccessSuccess = ({ open, onClose }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          backgroundColor: '#fff',
          backgroundImage: 'none',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            py: '24px',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: `${colors.greenAccent[500]}22`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: colors.greenAccent[500],
            }}
          >
            <CheckCircleIcon fontSize="large" />
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={700} sx={{ color: colors.grey[100], mb: '8px' }}>
              {t('dashboard.requestAccessSuccess.title')}
            </Typography>
            <Typography variant="body2" sx={{ color: colors.grey[300], lineHeight: 1.6 }}>
              {t('dashboard.requestAccessSuccess.subtitle')}
            </Typography>
          </Box>

          <Button
            variant="contained"
            fullWidth={false}
            onClick={onClose}
            sx={{
              mt: '8px',
              fontWeight: 700,
              textTransform: 'uppercase',
              fontSize: '13px',
            }}
          >
            {t('common.close')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalRequestAccessSuccess;
